import { useAlert } from '@ads/components-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useBatchStatusChange } from '@/features/student-management/hooks/useBatchStatusChange';
import { useBatchStatusGrid } from '@/features/student-management/hooks/useBatchStatusGrid';
import type { EnrollmentStatus } from '@/features/student-management/types/enrollment';
import { EnrollmentBatchStatusTemplate } from '@/features/student-management/ui/templates/EnrollmentBatchStatusTemplate';

export const Route = createFileRoute('/_authenticated/enrollments/batch-status/')({
  component: EnrollmentBatchStatusPage,
});

function EnrollmentBatchStatusPage() {
  const navigate = useNavigate();
  const { alert } = useAlert();
  const { t } = useTranslation('personManagement');

  const [classId, setClassId] = useState('');
  const [newStatus, setNewStatus] = useState<EnrollmentStatus | null>(null);

  const classStudentId = classId ? Number(classId) : null;
  const { eligibleStudents, totalEligibleCount, directCount, revertCount, isLoading } =
    useBatchStatusGrid(classStudentId, newStatus);

  // O endpoint de lote não informa se a turma emite certificado; a opção de envio
  // só faz sentido ao concluir com certificado.
  const hasCertificate = newStatus === 'finished_with_certificate';

  const { apply, isApplying } = useBatchStatusChange(() => {
    void navigate({ to: '/enrollments' });
  });

  return (
    <EnrollmentBatchStatusTemplate
      classId={classId}
      onClassChange={setClassId}
      newStatus={newStatus}
      onNewStatusChange={setNewStatus}
      eligibleStudents={eligibleStudents}
      isLoading={isLoading}
      isApplying={isApplying}
      totalEligibleCount={totalEligibleCount}
      directCount={directCount}
      revertCount={revertCount}
      hasCertificate={hasCertificate}
      onApply={data => apply(data, Number(data.classId))}
      onSaveDraft={() =>
        alert({
          alertType: 'warning',
          title: t('batchStatus.footer.draftNotImplemented'),
        })
      }
    />
  );
}
